import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, MessageCircle, Sparkles } from "lucide-react";
import { waLink } from "@/constants/site";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-32 pb-20 md:pt-44 md:pb-28 overflow-hidden bg-gradient-to-b from-[#F4F1F9] via-white to-white"
    >
      {/* Decorative blobs */}
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-[#E8E2F0] blur-3xl opacity-50 pointer-events-none" />
      <div className="absolute top-1/2 -left-40 w-[380px] h-[380px] rounded-full bg-[#F4F1F9] blur-3xl opacity-60 pointer-events-none" />

      <div className="iona-container relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 iona-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E8E2F0] text-xs tracking-wider uppercase text-[#5E2A84] mb-7">
              <Sparkles className="w-3.5 h-3.5" />
              Premium Güzellik Deneyimi
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A] mb-7">
              Güzelliğinize
              <br />
              <span className="iona-gradient-text italic">premium dokunuş</span>
              <br />
              ile başlayın.
            </h1>

            <p className="text-base sm:text-lg text-[#4A4A4A] max-w-xl leading-relaxed mb-10">
              İONA, Ümraniye'de lazer epilasyon, cilt bakımı, saten yüz germe,
              bölgesel incelme ve güzellik uygulamaları sunan profesyonel bir
              güzellik merkezidir. Ümraniye'nin kalbinde, sadece sizin için.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-whatsapp-btn"
              >
                <Button className="w-full sm:w-auto h-14 px-8 rounded-full bg-[#5E2A84] hover:bg-[#4a2168] text-white text-base iona-soft-shadow">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  WhatsApp'tan Randevu Al
                </Button>
              </a>
              <a href="#hizmetler" data-testid="hero-services-btn">
                <Button
                  variant="outline"
                  className="w-full sm:w-auto h-14 px-8 rounded-full border-[#5E2A84]/30 text-[#5E2A84] hover:bg-[#F4F1F9] hover:text-[#5E2A84] text-base"
                >
                  Hizmetleri İncele
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </a>
            </div>

            <div className="mt-12 flex items-center gap-8">
              <div>
                <div className="font-serif text-3xl text-[#5E2A84]">10+</div>
                <div className="text-xs uppercase tracking-wider text-[#4A4A4A]">Yıllık Deneyim</div>
              </div>
              <div className="w-px h-12 bg-[#E5E5E5]" />
              <div>
                <div className="font-serif text-3xl text-[#5E2A84]">5K+</div>
                <div className="text-xs uppercase tracking-wider text-[#4A4A4A]">Mutlu Müşteri</div>
              </div>
              <div className="w-px h-12 bg-[#E5E5E5]" />
              <div>
                <div className="font-serif text-3xl text-[#5E2A84]">15+</div>
                <div className="text-xs uppercase tracking-wider text-[#4A4A4A]">Premium Cihaz</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 relative iona-fade-up" style={{ animationDelay: "0.2s" }}>
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:max-w-none lg:ml-auto">
              <div className="absolute inset-0 rounded-[2rem] overflow-hidden iona-soft-shadow">
                <img
                  src="/services/hero-woman.png"
                  alt="İONA Güzellik Merkezi"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating accent card */}
              <div className="absolute -bottom-8 -left-6 sm:-left-12 bg-white rounded-2xl p-5 iona-soft-shadow border border-[#F0F0F0] max-w-[220px]">
                <div className="text-xs uppercase tracking-wider text-[#5E2A84] mb-2">
                  Ücretsiz
                </div>
                <div className="font-serif text-lg text-[#1A1A1A] leading-snug">
                  Deneme Seansı & Danışmanlık
                </div>
              </div>
              <div className="absolute -top-6 -right-4 sm:-right-8 bg-[#5E2A84] text-white rounded-full w-28 h-28 flex flex-col items-center justify-center iona-soft-shadow">
                <Sparkles className="w-5 h-5 mb-1" />
                <span className="font-serif text-sm leading-tight text-center">
                  Premium
                  <br />
                  Hizmet
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
